/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

/**
 * @Deprecated: Use "CommonUtils.color" instead
 */
export enum ColorHex {
  '#ed5565',
  '#ffce54',
  '#48cfad',
  '#4fc1e9',
  '#ac92ec',
  '#ec87c0',
  '#fc6e51',
}
